import React from 'react'

export const Icon = ({ name, onClick }) => (
  <i
    aria-hidden="true"
    className={`${name} big icon`}
    onClick={onClick}
  />
);

export const PlayButton = ({ onClick }) => (
  <div className="circle play">
    <Icon onClick={onClick} name="play" />
  </div>
);

export const EmptySpace = () => <div name="empty-space" />;

export const Arrow = ({ show, direction, onClick }) => show
  ? (<div className="circle arrow">
      <Icon onClick={onClick} name={`arrow ${direction}`} />
    </div>)
  : <EmptySpace />;

export const SoundControl = ({ show, enabled, onClick }) => show && (
  <div className="circle">
    <Icon onClick={onClick} name={`volume ${enabled ? 'up' : 'off'}`} />
  </div>
);

export const FullScreen = ({ show, onClick, enabled }) => show &&
  <Icon onClick={onClick} name={enabled ? 'compress' : 'expand'} />;

export const Close = ({ show, onClick }) => show && (
  <div className="close-button">
    <div className="circle">
      <Icon onClick={onClick} name="close" />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Icons/Icons.jsx